/**
 * API Client for Alerts and Thresholds endpoints
 */

import { apiClient, handleApiError } from './apiClient';

export interface AlertItem {
  id: string;
  thresholdId: string;
  metric: string;
  severity: 'info' | 'warning' | 'critical';
  message: string;
  currentValue: number;
  thresholdValue: number;
  status: 'active' | 'acknowledged' | 'resolved';
  triggeredAt: string;
  acknowledgedAt?: string;
  acknowledgedBy?: string;
  resolvedAt?: string;
}

export interface AlertThresholdItem {
  id: string;
  metric: string;
  operator: string;
  value: number;
  severity: 'info' | 'warning' | 'critical';
  description: string;
  enabled: boolean;
}

interface AlertsResponse {
  data: AlertItem[];
}

interface ThresholdsResponse {
  data: AlertThresholdItem[];
}

export async function fetchAlerts(): Promise<AlertItem[]> {
  try {
    const response = await apiClient.get<AlertsResponse>('/alerts');
    return response.data.data;
  } catch (error) {
    return handleApiError(error, 'Failed to fetch alerts');
  }
}

export async function fetchThresholds(): Promise<AlertThresholdItem[]> {
  try {
    const response = await apiClient.get<ThresholdsResponse>('/alerts/thresholds');
    return response.data.data;
  } catch (error) {
    return handleApiError(error, 'Failed to fetch thresholds');
  }
}

export async function acknowledgeAlert(alertId: string): Promise<void> {
  try {
    await apiClient.post(`/alerts/${encodeURIComponent(alertId)}/acknowledge`);
  } catch (error) {
    handleApiError(error, 'Failed to acknowledge alert');
  }
}
